export default __webpack_public_path__ + "static/media/placeholder1.68caf11e.png";